// mixpanel.interceptor.ts
import {Injectable} from "@angular/core";
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import mixpanel from "mixpanel-browser";

@Injectable()
export class MixpanelInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const startTime = performance.now();

        return next.handle(req).pipe(
            finalize(() => {
                const duration = performance.now() - startTime;
                if (duration > 4000) {
                    mixpanel.track("Slow API Call", {
                        endpoint: req.url,
                        method: req.method,
                        duration: duration.toFixed(0),
                    });
                }
            })
        );
    }
}
